import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {ApiService} from '@drl/core/api/api.service';
import {GetListAPICommand} from '@drl/core/api/commands';
import {environment} from '@drl/env/environment';
import {PhrTags} from '../models/phr-tags.model';

export class GetPhrTagsCommand extends GetListAPICommand<PhrTags> {
  constructor(apiService: ApiService, adapter: IAdapter<PhrTags>) {
    super(apiService, adapter, `${environment.patientApiUrl}/phr-tags`);
  }
}
